import React from 'react';

const JoinOurTeam = () => {
  return (
    <div className="text-white font-sans overflow-hidden">
      <section className="max-w-[1400px] mx-auto py-2 px-1 md:px-1">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-20">

          {/* LEFT CONTENT */}
          <div className="w-full lg:w-[55%] space-y-6 md:space-y-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-green-500 leading-tight">
              Careers at SecuWall
            </h2>

            <div className="space-y-4 md:space-y-6 text-[#D1D5DB] text-base md:text-lg leading-relaxed font-medium">
              <p>
                Join a team of passionate cybersecurity professionals making a real impact in defending organizations worldwide.
              </p>
              {/* BULLET POINTS SECTION */}
              <ul className="space-y-1 pt-2">
                {[
                  { label: "Innovative Environment", desc: "Work with cutting-edge tools and Alpha AI technology." },
                  { label: "Global Collaboration", desc: "Diverse, international team with flexible remote options." },
                  { label: "Growth Opportunities", desc: "Continuous training, certifications, and career advancement." },
                  { label: "Meaningful Mission", desc: "Protect businesses and contribute to a safer digital world." }
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <p>
                      <span className="text-orange-500 font-bold">{item.label}:</span> {item.desc}
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            
          </div>

          {/* RIGHT IMAGE */}
          <div className="w-full lg:w-[55%]">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/career.jpg"
                alt="SecuWall Office Collaboration"
                className="w-full h-auto object-cover min-h-[220px] sm:min-h-[350px] lg:min-h-[450px]"
              />
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default JoinOurTeam;